export default __webpack_public_path__ + "static/media/wh_8.05784e63.mp3";